import React, { Component } from "react";
import { Table, Card, Row, Col, Form, Image } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import PatientsViewModel from "./PatientsViewModel";
import PatientsActive from "./PatientsActive";
import "../../Common/Common.css";
var dateFormat = require("dateformat");

class PatientsProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      patientuserShow: false,
      showPatientsActive: false,
      page: 0,
      perPage: 10,
      searchpatients: "",
      filterValue: "",
      patientuserDtls: []
    };
  }

  componentDidMount() {
    this.props.PatientUser({pageno:undefined,search:this.state.searchpatients,filter:this.state.filterValue});
  }

  //Search function
  SearchOnChange = event => {
    this.setState({
      filterValue: "",
      searchpatients: event.target.value,
      page:0
    },()=>{this.props.PatientUser({pageno:undefined,search:this.state.searchpatients,filter:""});});
  };

  //Filter function
  handleChange = event => {
    this.setState({
      page: 0,
      filterValue: event.target.value,
      searchpatients: ""
    },()=>{this.props.PatientUser({pageno:undefined,search:"",filter:this.state.filterValue});});
  };

  //Pagination
  handlePageClick = e => {
    const selectedPage = e.selected;
    this.props.PatientUserSlectedPage({pageno:selectedPage + 1,search:this.state.searchpatients,filter:this.state.filterValue});
    this.setState({ page: selectedPage });
  };

  resetPage = () => {
    this.setState({ page: 0 });
  };

  
  handlePatientsView = item => {
    this.setState(
      {
        ...this.state,
        patientuserShow: true,
        patientuserDtls: item
      },
      () => {
        this.props.PatientsDetailsview(item.item.id);
        this.props.PatientPrescriptionview({
          item: this.state.patientuserDtls,
          page: undefined
        });
      }
    );
  };

  handleClosePatientsView = () => {
    this.setState({ patientuserShow: false });
  };

  handlePatientsActiveView = item => {
    this.setState({
      showPatientsActive: true,
      PatientsActiveActvDtls: item
    });
  };
  handleCloseActive = () => {
    this.setState({ showPatientsActive: false });
  };

  



  render() {
    //Destructuring
    const {page,perPage,searchpatients,filterValue,showPatientsActive,PatientsActiveActvDtls,patientuserShow,patientuserDtls} = this.state;
    const {itemcount,patientuserDtlsCount,patientuserDtlsList,PatientsInActive,patientsmainDtls,patientsprscrptnls,patientsprscrptnlsCount, itempageSelected} = this.props;
    const {SearchOnChange,handleChange,handlePatientsView,handlePatientsActiveView,handleCloseActive,resetPage,handleClosePatientsView,itemsPageClick,handlePageClick} = this;

    //For pagination
    let p = page + 1;
    const count = patientuserDtlsCount ?patientuserDtlsCount:0;
    let PatientUserPageCount = Math.ceil(count / perPage);

    return (
      <div>
        <Card>
          <Card.Header>
            <Row className="align-items-center w-100 justify-content-between tableHeaderRow">
              <Col xs={12} sm={12} md={3} lg={3}>
                <h3>Profiles</h3>
              </Col>

              <Col xs={12} sm={12} md={3} lg={3}>
                <div className="commonFilterDiv">
                  <select value={filterValue} onChange={handleChange} className="commonFilterSelect">
                    <option value="">All</option>
                    <option value="active">Active</option>
                    <option value="suspended">Suspended</option>
                  </select>
                </div>
              </Col>

              <Col xs={12} sm={12} md={3} lg={3}>
                <div className="commonInput">
                  <i className="fa fa-search fa-lg cmnSearchIcon"></i>
                  <input type="text" placeholder="User/ Mobile no" value={searchpatients} onChange={SearchOnChange}/>
                </div>
              </Col>
              
              <Col xs={12} sm={12} md={3} lg={3}>
                <div className="commonRecrd">
                  <i className="cui-note icons cmnRecordIcon"></i>
                  <span className="cmnPageCount">{count === undefined ?0 :count}</span>
                  <span className="cmnResutText">Results</span>
                </div>
              </Col>
            </Row>
          </Card.Header>

          <Card.Body>
            <div>
              <Table responsive bordered striped className="cmnMainTable">
                <thead>
                  <tr className="cmnMainTableHd">
                    <th>SL NO</th>
                    <th>USER NAME</th>
                    <th>MOBILE </th>
                    <th>PROFILE UPDATE</th>
                    <th>CREATED DATE</th>
                    <th>STATUS</th>
                    <th>ACTION</th>
                  </tr>
                </thead>
                <tbody>
                  {patientuserDtlsList &&patientuserDtlsList.map((item, i) => (
                    <tr key={i}>
                      <td className="cmn_Cap">{10 * (p - 1) + i + 1}</td>
                      <td className="cmn_Cap">
                        {item !== null &&item.fullName?item.fullName:""}
                      </td>

                      <td className="">{item !== null && item.mobileNo}</td>
                      <td className="">{item !== null && item.ftLogin ? "Pending" : "Updated"}</td>
                      <td className="cmn_Cap ">
                        {item.createdAt !== null &&
                        dateFormat(item.createdAt, "mediumDate")}
                      </td>

                      <td className="cmn_Cap ">{item !== null && item.status}</td>
                      <td className="cmnViewIcon">
                        <div style={{display: "flex",justifyContent: "center"}}>
                          <i className="fa fa-eye fa-lg "onClick={() =>handlePatientsView({ item: item })}></i>
                          <i className="fa fa-ban fa-lg" style={{ paddingLeft: 10 }} onClick={() =>handlePatientsActiveView({item: item})}></i>
                          
                          <PatientsActive
                            show={showPatientsActive}
                            handleClose={handleCloseActive}
                            PatientsActiveActvDtls={PatientsActiveActvDtls}
                            PatientsInActive={PatientsInActive}
                            resetPage={resetPage}
                          />

                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>

              <PatientsViewModel
                show={patientuserShow}
                handleClose={handleClosePatientsView}
                patientuserDtls={patientuserDtls}
                patientsmainDtls={patientsmainDtls}
                patientsprscrptnls={patientsprscrptnls}
                patientsprscrptnlsCount={patientsprscrptnlsCount}
                itemsPageClick={itemsPageClick}
                itempageSelected={itempageSelected}
                itemcount={itemcount}
              />

              {(patientuserDtlsList === undefined ||(patientuserDtlsList &&patientuserDtlsList.length === 0)) && (
                <div>
                  <div className="noDataImgDiv">
                    <Image className="noDataImg" src={require("../../../../src/assets/img/nodata4.png")}/>
                  </div>
                  <div className="noDataTextDiv">No Profiles Found</div>
                </div>
              )}
            </div>
          </Card.Body>

          {PatientUserPageCount > 1 ? (
            <div className="paginationDiv">
              <ReactPaginate
                forcePage={page}
                previousLabel={"Prev"}
                nextLabel={"Next"}
                breakLabel={"..."}
                breakClassName={"break-me"}
                pageCount={PatientUserPageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={handlePageClick}
                containerClassName={"pagination flex-wrap"}
                subContainerClassName={"pages pagination"}
                activeClassName={"active"}
              />
            </div>
          ) : null}
        </Card>
      </div>
    );
  }
}
export default PatientsProfile;